export default __webpack_public_path__ + "static/media/twitterTheme-girl.c3c31223.svg";